var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.styleObject ? _vm.styleObject : _vm.styleObj)},[_vm._v(_vm._s(_vm.amount))])
}
var staticRenderFns = []

export { render, staticRenderFns }